import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import Platform from "react-native-web/dist/exports/Platform";
import Dimensions from "react-native-web/dist/exports/Dimensions";
import I18nManager from "react-native-web/dist/exports/I18nManager";

var _Dimensions$get = Dimensions.get('window'),
    height = _Dimensions$get.height,
    width = _Dimensions$get.width;

export var isRTL = I18nManager.isRTL;

if (typeof isRTL !== 'undefined' && isRTL && isRTL === Object(isRTL) && Object.isExtensible(isRTL) && !isRTL.hasOwnProperty('__filemeta')) {
  Object.defineProperty(isRTL, '__filemeta', {
    configurable: true,
    value: {
      name: "isRTL",
      filename: "node_modules/react-native-calendars/src/expandableCalendar/commons.js"
    }
  });
}

export var isAndroid = Platform.OS === 'android';

if (typeof isAndroid !== 'undefined' && isAndroid && isAndroid === Object(isAndroid) && Object.isExtensible(isAndroid) && !isAndroid.hasOwnProperty('__filemeta')) {
  Object.defineProperty(isAndroid, '__filemeta', {
    configurable: true,
    value: {
      name: "isAndroid",
      filename: "node_modules/react-native-calendars/src/expandableCalendar/commons.js"
    }
  });
}

export var isIos = Platform.OS === 'ios';

if (typeof isIos !== 'undefined' && isIos && isIos === Object(isIos) && Object.isExtensible(isIos) && !isIos.hasOwnProperty('__filemeta')) {
  Object.defineProperty(isIos, '__filemeta', {
    configurable: true,
    value: {
      name: "isIos",
      filename: "node_modules/react-native-calendars/src/expandableCalendar/commons.js"
    }
  });
}

export var screenWidth = width;

if (typeof screenWidth !== 'undefined' && screenWidth && screenWidth === Object(screenWidth) && Object.isExtensible(screenWidth) && !screenWidth.hasOwnProperty('__filemeta')) {
  Object.defineProperty(screenWidth, '__filemeta', {
    configurable: true,
    value: {
      name: "screenWidth",
      filename: "node_modules/react-native-calendars/src/expandableCalendar/commons.js"
    }
  });
}

export var screenHeight = height;

if (typeof screenHeight !== 'undefined' && screenHeight && screenHeight === Object(screenHeight) && Object.isExtensible(screenHeight) && !screenHeight.hasOwnProperty('__filemeta')) {
  Object.defineProperty(screenHeight, '__filemeta', {
    configurable: true,
    value: {
      name: "screenHeight",
      filename: "node_modules/react-native-calendars/src/expandableCalendar/commons.js"
    }
  });
}

export var screenAspectRatio = screenWidth < screenHeight ? screenHeight / screenWidth : screenWidth / screenHeight;

if (typeof screenAspectRatio !== 'undefined' && screenAspectRatio && screenAspectRatio === Object(screenAspectRatio) && Object.isExtensible(screenAspectRatio) && !screenAspectRatio.hasOwnProperty('__filemeta')) {
  Object.defineProperty(screenAspectRatio, '__filemeta', {
    configurable: true,
    value: {
      name: "screenAspectRatio",
      filename: "node_modules/react-native-calendars/src/expandableCalendar/commons.js"
    }
  });
}

export var isTablet = Platform.isPad || screenAspectRatio < 1.6 && Math.max(screenWidth, screenHeight) >= 900;

if (typeof isTablet !== 'undefined' && isTablet && isTablet === Object(isTablet) && Object.isExtensible(isTablet) && !isTablet.hasOwnProperty('__filemeta')) {
  Object.defineProperty(isTablet, '__filemeta', {
    configurable: true,
    value: {
      name: "isTablet",
      filename: "node_modules/react-native-calendars/src/expandableCalendar/commons.js"
    }
  });
}

export var todayString = 'today';

if (typeof todayString !== 'undefined' && todayString && todayString === Object(todayString) && Object.isExtensible(todayString) && !todayString.hasOwnProperty('__filemeta')) {
  Object.defineProperty(todayString, '__filemeta', {
    configurable: true,
    value: {
      name: "todayString",
      filename: "node_modules/react-native-calendars/src/expandableCalendar/commons.js"
    }
  });
}

export var UPDATE_SOURCES = {
  CALENDAR_INIT: 'calendarInit',
  TODAY_PRESS: 'todayPress',
  LIST_DRAG: 'listDrag',
  DAY_PRESS: 'dayPress',
  PAGE_SCROLL: 'pageScroll',
  WEEK_SCROLL: 'weekScroll',
  PROP_UPDATE: 'propUpdate'
};

if (typeof UPDATE_SOURCES !== 'undefined' && UPDATE_SOURCES && UPDATE_SOURCES === Object(UPDATE_SOURCES) && Object.isExtensible(UPDATE_SOURCES) && !UPDATE_SOURCES.hasOwnProperty('__filemeta')) {
  Object.defineProperty(UPDATE_SOURCES, '__filemeta', {
    configurable: true,
    value: {
      name: "UPDATE_SOURCES",
      filename: "node_modules/react-native-calendars/src/expandableCalendar/commons.js"
    }
  });
}